import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const InstitutionForm = () => {
  const [formData, setFormData] = useState({
    institutionName: '',
    ownerName: '',
    ownerPhoneNumber: '',
    trainerName: '',
    district: '',
    taluka: '',
    institutionType: '',
    password: '',
    referralid: localStorage.getItem('UserId'),
    RetypePassword: '',
  });

  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

   useEffect(() => {
     // Fetch Districts from API
     fetch(`${process.env.REACT_APP_API}/locations/districts`)
       .then((res) => res.json())
       .then((data) => setDistricts(data))
       .catch((err) => console.error("Error fetching districts:", err));
   }, []);
 
   useEffect(() => {
     const selectedDistrict = districts.find(d => d.name === formData.district);
   
     if (selectedDistrict?.id) {
       fetch(`${process.env.REACT_APP_API}/locations/taluks?district_id=${selectedDistrict.id}`)
         .then((res) => res.json())
         .then((data) => setTalukas(data))
         .catch((err) => console.error("Error fetching taluks:", err));
     } else {
       setTalukas([]);
     }
   }, [formData.district, districts]); 
   

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation checks
    if (formData.password !== formData.RetypePassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }

    // Validate phone number (must be 10 digits)
    if (formData.ownerPhoneNumber.length !== 10) {
      setErrorMessage('Phone number should be exactly 10 digits');
      return;
    }

    const viewPass = false; // Can toggle based on admin settings

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/instituteform/addinstitution`, {
        ...formData,
        viewPass,
      });
        alert('Form submitted successfully!')
      // Reset form on success
      setFormData({
        institutionName: '',
        ownerName: '',
        ownerPhoneNumber: '',
        trainerName: '',
        district: '',
        taluka: '',
        institutionType: '',
        password: '',
        referralid: localStorage.getItem('UserId'),
        RetypePassword: '',
      });

      setErrorMessage('');
      setSuccessMessage('Form submitted successfully!');
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Error submitting the form.');
      setSuccessMessage('');
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  return (
    <div>
      <div style={{ marginBottom: '50px' }}>
        <Link to="/" className="logo_image">
          <img src="assets/headimg.jpg" alt="Cleenhearts HTML" style={{ width: '100%' }} />
        </Link>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <form
          onSubmit={handleSubmit}
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '50%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <input
            type="text"
            id="institutionName"
            placeholder="Institution Name"
            value={formData.institutionName}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
          />

          <input
            type="text"
            id="ownerName"
            placeholder="Owner Name"
            value={formData.ownerName}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
          />

          <input
            type="tel"
            id="ownerPhoneNumber"
            placeholder="Owner Phone Number"
            maxLength={10}
            value={formData.ownerPhoneNumber}
            onChange={(e) => {
              const newValue = e.target.value.replace(/[^0-9]/g, ''); 
              setFormData((prevData) => ({
                ...prevData,
                ownerPhoneNumber: newValue,
              }));
            }}
            style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
          />

          <input
            type="text"
            id="trainerName"
            placeholder="Trainer Name"
            value={formData.trainerName}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
          />

          <select
            id="district"
            value={formData.district}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
          >
             <option value="">Select District</option>
          {districts.map((district) => (
            <option key={district.id} value={district.name}>
              {district.name}
            </option>
          ))}
          </select>

          <select
            id="taluka"
            value={formData.taluka}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
          >
             <option value="">Select Taluk</option>
          {talukas.map((taluk) => (
            <option key={taluk.id} value={taluk.name}>
              {taluk.name}
            </option>
          ))}
          </select>

          <select
            id="institutionType"
            value={formData.institutionType}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
          >
            <option value="">Select Institution Type</option>
            <option value="Computer Education">Computer Education</option>
            <option value="Ari Work And Design">Ari Work And Design</option>
            <option value="Tailoring">Tailoring</option>
          </select>

          <input
            type="password"
            id="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
          />

          <input
            type="password"
            id="RetypePassword"
            placeholder="Retype Password"
            value={formData.RetypePassword}
            onChange={handleChange}
            style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
          />

          <button
            type="submit"
            style={{
              padding: '10px 20px',
              backgroundColor: '#007BFF',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
              width: '30%',
              borderRadius: '10px',
            }}
          >
            Submit
          </button>

          {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
        </form>
      </div>
    </div>
  );
};

export default InstitutionForm;
